module.exports = __webpack_public_path__ + "img/UI_common_framelabelPX_01_d689db7ac.png";